/**
 * Rendered by render.php: the button needs the post id and the query id, and
 * neither exists at save time.
 */
export default function Save() {
  return null;
}
